'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _httpRequest = require('@souche-f2e/http-request');

var _httpRequest2 = _interopRequireDefault(_httpRequest);

var _soucheUtil = require('@souche-f2e/souche-util');

var _soucheUtil2 = _interopRequireDefault(_soucheUtil);

var _variable = require('./variable');

var _variable2 = _interopRequireDefault(_variable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

var BuryServer = ''; // 埋点的服务器地址

/**
 * @desc 埋点文档： http://datacenter-log-center-test.sqaproxy.souche.com/api#!/trackapi/commonAdd
 * 密码： souche_doc_2018
 * token        // 有手机号时用token,无手机号的时候可以不传
 * usertag      // userTag  不需要，则不用传
 * typeId       // 数据平台定义的key名，例如TYPE_CHENIU
 * platform     // 数据平台定义的「平台/业务方」对应的 key
 *              // 其他附属字段直接跟在body中，会当做ext参数传入数据平台
 */

var Bury = function () {
    function Bury() {
        (0, _classCallCheck3.default)(this, Bury);

        this.disable = false;
    }

    /**
     * 请求埋点接口
     */


    (0, _createClass3.default)(Bury, [{
        key: 'request',
        value: function request(params) {
            if (this.disable) {
                return;
            }
            this.params = params;
            _variable2.default.send(this.params);
            _soucheUtil2.default.setCookie('bury_typeid', this.params.typeId);
            if (_variable2.default.bury) {
                _variable2.default.bury(this.params);
                return Promise.resolve();
            }

            return _httpRequest2.default.ajax({
                url: BuryServer,
                data: this.params
            });
        }
    }]);
    return Bury;
}();

exports.default = {
    init: function init(Vue) {
        var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'production';

        var HOST_MAP = {
            'development': 'https://datacenter-log-center.dasouche-inc.net',
            'prepub': 'https://traffic-v1.prepub.souche.com',
            'production': 'https://traffic-v1.souche.com'
        };
        var buryUrl = HOST_MAP[env] || HOST_MAP['production'];
        BuryServer = buryUrl + '/api/trackApi/commonAdd.json';

        return Bury;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-vue/vue-burying/dist/bury.js
// module id = efvW
// module chunks = 11